import { render } from "./CompanyModule.vue?vue&type=template&id=54566fbf&scoped=true"
import script from "./CompanyModule.vue?vue&type=script&lang=js"
export * from "./CompanyModule.vue?vue&type=script&lang=js"

import "./CompanyModule.vue?vue&type=style&index=0&id=54566fbf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54566fbf"]])

export default __exports__